<template>
  <div>
    <div class="hdp-head">
      <StepBack @route="onRoute" :route="{name: 'FolderView', params: {folderId: article.folder_id}}" />
      <div class="hdp-h1">{{ article.title }}</div>
    </div>
    <div class="hdp-article" v-html="article.description"></div>
  </div>
</template>

<script>
import StepBack from '@/components/StepBack'

export default {
  name: 'ArticleItem',

  components: {
    StepBack
  },

  props: {
    article: {
      type: Object,
      required: true
    }
  },

  updated () {
    Array.prototype.forEach.call(this.$el.querySelectorAll('table'), (table, i) => {
      table.outerHTML = '<div class="hdp-table-wrap">' + table.outerHTML + '</div>'
    })
  },

  methods: {
    onRoute (route) {
      this.$emit('route', route)
    }
  }
}
</script>

<style>
  .hdp-article {
    margin: 18px 0;
  }
  .hdp-article img {
    display: block;
    max-width: 100%;
    height: auto !important;
    margin-top: 8px;
    margin-bottom: 8px;
  }
  .hdp-article a {
    color: rgba(126, 152, 229, 1);
  }
  .hdp-article .fr-video {
    display: block;
    width: 100%;
    margin-top: 10px;
  }
  .hdp-article .fr-video iframe {
    max-width: 100%;
  }
  .hdp-article p {
    margin: 16px 0;
  }
  .hdp-article p br {
    display: none;
  }
  .hdp-article .hdp-table-wrap {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .hdp-article table {
    width: 100%;
    border-collapse: collapse;
    border: 1px solid #fff;
  }
  .hdp-article table td,
  .hdp-article table th {
    padding: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/ArticlesItem.vue